import React from "react";
import LinesEllipsis from "react-line-ellipsis";

export default function MoreDescription({ text }) {
  const moreText = (
    <span style={{ color: "#004BFE" }}>&nbsp; &nbsp;ادامه ... &nbsp;</span>
  );
  return (
    <div>
      <LinesEllipsis
        text={text}
        ellipsis={moreText}
        trimRight
        basedOn="letters"
        maxLine="2"
      />
    </div>
  );
}
